export class NormalResultHistory {

    HistoryOrder: number;
    Date: Date;
    Result: string;

    constructor() { }
}